import React, { Component } from 'react';
import { connect } from 'react-redux';
import Spinner from '../UI/Spinner';
import Breadcrumb from '../UI/Breadcrumb';
import CustomerForm from './CustomerForm';
import { getCustomer } from '../../store/actions';


class EditCustomer extends Component {

    componentDidMount() {
        const customerId = this.props.match.params.id;
        this.props.getCustomer(customerId);
    }

    render() {
        if (!this.props.customer) return <Spinner />;
        const { customer } = this.props;
        return (
            <React.Fragment>
                <div className="page-title">
                    <div className="container">
                        <div className="row flex-center-y justify-between">
                            <div className="col-xs-12 text-center">
                                <h1 className="color-grey capitalize">Edit customer</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <Breadcrumb from={[{link: '/customers', label: 'Customers list'}]} current="Edit Customer"/>
                </div>
                <div className="container box inner-padding mb-15">
                    { customer && <CustomerForm customer={customer} { ...this.props }></CustomerForm> }
                </div>
            </React.Fragment>
        );
    }
}


const mapStateToProps = state => {
    return {
        customer: state.customer.customer
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getCustomer: id => dispatch( getCustomer(id) )
    }
};

export default connect(mapStateToProps, mapDispatchToProps)( EditCustomer );



// WEBPACK FOOTER //
// ./src/components/Customer-administrator/EditCustomer-f.js